import React from 'react';

import './HorizontalLine.css';

interface Props {
  additionalClasses?: string;
}

const HorizontalLine: React.FC<Props> = props => {
  return <div className={`ui-widget-separator-horizontal ${props.additionalClasses}`} />;
};

export default HorizontalLine;
